module.exports = __webpack_public_path__ + "img/justine_wichmann_3.c7fb44aa.jpg";